import { render, staticRenderFns } from "./BusinessOrderDisable.vue?vue&type=template&id=57ba0236&scoped=true&"
import script from "./BusinessOrderDisable.vue?vue&type=script&lang=js&"
export * from "./BusinessOrderDisable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ba0236",
  null
  
)

export default component.exports